<template lang="html">
  <div class="">
    <AppRenderer class="app-renderer" />
  </div>
</template>

<script>
import AppRenderer from '@/components/Scene/AppRenderer'
export default {
  components: {
    AppRenderer
  }
}
</script>

<style lang="scss" scoped>
.app-renderer {
  @apply fixed inset-0
}

@screen md {
  .app-renderer {
    @apply fixed inset-0
  }
}
</style>
